import type { ComponentSchema } from '../../../../../schema-types'
import { CONTENT_PAGES, headingFields, SECTION_STYLE_FIELDS } from './_fields'

/** Category tiles: chosen categories or links, or the store's categories when none are listed. */
export const schema: ComponentSchema = {
  type: 'category-bento',
  label: 'Category tiles',
  description: 'Category tiles with the product shot beside the name (2 / 4 per row), or picture tiles (3 / 6 per row).',
  supportedPages: CONTENT_PAGES,
  variants: [
    { id: 'v1', label: 'Picture beside the name (2 / 4 per row)' },
    { id: 'v2', label: 'Picture above the name (3 / 6 per row)' },
  ],
  commonFields: [
    ...headingFields({ title: '' }),
    {
      key: 'tiles',
      label: 'Tiles',
      type: 'array',
      help: 'Empty = the store’s categories. Leave the title empty for a grid without a heading.',
      itemSchema: [
        { key: 'categoryId', label: 'Category', type: 'category-select', help: 'Sets the link, name and picture unless filled below.' },
        { key: 'title', label: 'Name', type: 'localized-string' },
        { key: 'tagline', label: 'Tagline', type: 'localized-string', help: 'Shown when the category has no product count.' },
        { key: 'image', label: 'Picture', type: 'image' },
        { key: 'link', label: 'Link', type: 'string', placeholder: '/category/…' },
      ],
      default: [],
    },
    { key: 'limit', label: 'Categories shown (automatic tiles)', type: 'number', default: 24 },
    ...SECTION_STYLE_FIELDS,
  ],
}
